import httpErrorStatus from "utilities/httpErrorStatus";

/**
 * React Query options for `useMessagesSuspenseQuery`. Retries transient
 * failures (network errors, 5xx) up to 3 times with default exponential
 * backoff (~1s, 2s, 4s). Client errors (4xx) are terminal and not retried.
 */
export const MESSAGES_READ_OPTIONS = {
  retry: (failureCount: number, error: Error) => {
    const status = httpErrorStatus(error);
    if (status !== undefined && status >= 400 && status < 500) return false;
    return failureCount < 3;
  },
} as const;
